import script from "./boardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardPage.vue?vue&type=script&setup=true&lang=js"

import "./boardPage.vue?vue&type=style&index=0&id=1659f176&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1659f176"]])

export default __exports__